"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
exports.GLOBALS = new core_1.InjectionToken('Global config for sortablejs');
//# sourceMappingURL=globals.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-sortablejs/dist/src/globals.js
// module id = 127
// module chunks = 4